import { color } from '../../themer/theme/color';

export const theme = {
	background: color.state.warning,
	emergencyBackground: color.state.error,
	title: {
		fontSize: '20px',
	},
};
